/**
 * Regex that will be used throught the app.
 */
export default {
  encodeComment: /<span class="mention" data-index="\d+" data-denotation-char="@" data-value="([a-zA-Z0-9$!@#%^&,' ]*?)" data-id="(\w+?)">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@<\/span>[a-zA-Z0-9$!@#%^&,' ]*<\/span>﻿<\/span>/,
  decodeComment: /@\[(.*?)]\(userId:(\w+)\)/,
  detectAllMentionsInComment: /@\[(.*?)]\(userId:(\w+)\)/g,
  detectAddOnPackAmount: /[£€$]\d{1,4}/,
  attachmentTextContentInsideMessage: /<attachment id="[a-zA-Z\d-]+"><\/attachment>/ig
};
